import React from "react";
import ReactDOM from "react-dom";
import Routes from "./routes";
import { GlobalStyles } from "./styles";

// Alterado para o Routes por necessidade de utilizar o location (Question 12) nos componentes 
// import { Criare } from "./apps";

ReactDOM.render(
  <>
    <GlobalStyles />
    <Routes />
  </>,
  document.getElementById("root")
);
